import {NgModule} from '@angular/core';
import {CadCamService} from '@infrastructure/cad-cam/cad-cam.service';
import {DownloadDrawingComponent} from '@presentation/components/download/download-drawing.component';
import {DrawingListComponent} from '@presentation/components/drawing-list/drawing-list.component';
import {SharedModule} from '@shared/shared.module';
import {DrawingLibraryListViewComponent} from './drawing-library-new-listview/drawing-library-listview.component';

@NgModule({
  imports: [SharedModule],
  exports: [DrawingListComponent, DrawingLibraryListViewComponent],
  providers: [CadCamService],
  declarations: [DrawingListComponent, DownloadDrawingComponent, DrawingLibraryListViewComponent]
})
export class DrawingLibrarySharedModule {}
